import { AxiosResponseHeaders } from 'axios';
import { CulturesResponseDTO, Locale } from '../entities';

const culturesResponseDTOToLocalesAdapter = (data: CulturesResponseDTO, headers?: AxiosResponseHeaders): Locale[] => {
  if (!data.body) {
    throw new Error('Error');
  }

  // TODO: use the class constructor to create proper objects once response is provided
  return data.body.cultures.map(
    language =>
      new Locale(
        language.id,
        language.cultureName,
        language.displayNameLong,
        language.displayNameShort,
        language.languageRegion,
      ),
  );
};

export { culturesResponseDTOToLocalesAdapter };
